import React, { useEffect } from 'react';
import { updateSEO } from '../utils/seo';

const TermsOfService: React.FC = () => {
  useEffect(() => {
    updateSEO({ title: 'Terms of Service' });
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-6 py-24">
      <h1 className="text-5xl font-black uppercase text-black mb-12">Terms of Service</h1>
      <div className="prose prose-lg">
        <p>By using PageDraft, you agree to abide by these terms. We provide a workspace for professional drafting.</p>
      </div>
    </div>
  );
};

export default TermsOfService;